/*

makeAjaxRequest takes a simple description, i.e. 'ssr code block 26'

a request is made, it goes to pendingRequests

the abortcontroller or whatever watches the request, if it takes more than 8 seconds...
 - show the gmail we're having a problem thing
 if pending requests are happening, show a little icon that shit is happening


 well, we want to show the request is happening...

 so in the top right, show a bar (make it look more like gmail, not these huge fuckin things...)

 slow request: 'ssr code block 26' is taking longer than expected... details (defensiveCopy(request[index]))

 which opens request details with the pending request...
   - which then says 'success' if it succeeded
   - or says 'failure' if it failed

  if a request fails, open a big ass dialog - i.e. the failure dialog

  failed request 1/1

  request details

  close / continue (if we aren't on the last request)
*/

export enum HttpStatusCode {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  EXPIRED = 419,
  INTERNAL_SERVER_ERROR = 500
}
